<script lang="ts">
import { AppFormatDateComponent } from "./app-format-date.ts";
export default AppFormatDateComponent;
</script>

<template>
    {{ formattedValue }}
</template>
